import { NAVBAR } from 'composer-blocks/lib/constants/BlockTypes';
import * as contentTypes from 'composer-blocks/lib/constants/ContentTypes';

export default {
  id: 'navbar_1',
  type: NAVBAR,
  name: 'Navbar 1',
  thumbnail: 'https://eventtia-composer.s3.amazonaws.com/assets/images/thumbnails/navbar/navbar_1.png',
  rootContent: {
    type: contentTypes.NAVBAR,
    properties: {
      backgroundColor: {type: 'css', value: 'white',editable: true},
      color: {type: 'css', value: '#919191',editable: true},
      padding: {type: 'css', value: '0.5rem 1rem'},
      fontSize: {type: 'css', value: 'small', editable: true},
      logoSrc: {type: 'custom', value: '', editable: true},
      logoHeight: {type: 'custom', value: '3.5rem'},
      navItemHoverUnderline: {type: 'custom', value: '#5d40ad', editable: true},
      navItemActiveUnderline: {type: 'custom', value: '#5d40ad', editable: true},
      navItemPadding: {type: 'custom', value: '0.5rem'},
      socialMedia: {type: 'custom', value: true, editable: true},
      facebookLink: {type: 'custom', value: 'facebook.com', editable: true},
      twitterLink: {type: 'custom', value: 'twitter.com', editable: true},
      linkedInLink: {type: 'custom', value: 'linkedin.com', editable: true},
      socialMediaIconColor: {type: 'custom', value: '#919191', editable: true},
    },
    contents: []
  }
}
